// Pulled this plugin from https://engineroom.teamwork.com/vue-js-advanced-reactivity-api-and-caching-method-style-getters-a80979b6660
// If we need this in future, the author wrote a gist that includes a way to limit how deep the cache goes:
// https://gist.github.com/mikeapr4/8436ce26952bae0e20072eb6d10ff43a

// recreation of a computed property
const computed = ( vm, func ) => {
	vm.$watch(
		func,
		null, // callback not used for lazy
		{ lazy: true, } // lazy means we can just flag as dirty
	);
	// eslint-disable-next-line no-underscore-dangle
	const watcher = vm._watchers[ vm._watchers.length - 1 ];

	// add an accessor
	watcher.lazyValue = () => {
		if ( watcher.dirty ) {
			watcher.evaluate();
		}
		watcher.depend(); // means any calling computed will have transitive deps
		return watcher.value;
	};
	return watcher;
};

// Cache Wrapper for Method-style Getter
const methodStyleCache = ( getVM, getter ) => {
	let watchers = {};
	return ( ...args ) => {
		// Remove old watchers if the getter is rebuilt
		Object.values( watchers ).forEach( w => w.teardown() );
		watchers = {};
		const innerMethod = getter( ...args );

		return ( ...cachedGetterArgs ) => {
			const id = JSON.stringify( cachedGetterArgs );
			let watcher = watchers[ id ];
			if ( !watcher ) {
				watcher = computed( getVM(), () => innerMethod( ...cachedGetterArgs ) );
				watchers[ id ] = watcher;
			}
			return watcher.lazyValue();
		};
	};
};

  // Cacher that can be attached as a plugin to get a store reference
const methodGetterCacher = () => {
	let store;
	const getVM = () => store._vm;
	return {
		plugin: st => { store = st; },
		cache: getter => methodStyleCache( getVM, getter ),
	};
};

export const { plugin, cache, } = methodGetterCacher();



// WEBPACK FOOTER //
// ./src/helpers/enhancedArrowGetters.js